const STALE_AZURE_HOSTS = {
  "stgcajobprod.blob.core.windows.net": "cajobportalstorage.blob.core.windows.net",
};

const DEFAULT_STORAGE_BASE =
  "https://cajobportalstorage.blob.core.windows.net/files/";

export const getStorageBaseUrl = () => {
  const configured = process.env.REACT_APP_AZURE_STORAGE_URL || DEFAULT_STORAGE_BASE;
  return configured.endsWith("/") ? configured : `${configured}/`;
};

/** Turn a slider/resume path or stale Azure URL into a loadable blob URL. */
export const resolveStorageUrl = (path) => {
  if (!path || typeof path !== "string") return "";
  const trimmed = path.trim();
  if (!trimmed) return "";

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      const replacement = STALE_AZURE_HOSTS[url.host];
      if (replacement) {
        url.host = replacement;
      }
      return url.toString();
    } catch {
      return trimmed.replace(
        "stgcajobprod.blob.core.windows.net",
        "cajobportalstorage.blob.core.windows.net"
      );
    }
  }

  const file = trimmed.replace(/^\//, "");
  return `${getStorageBaseUrl()}${file
    .split("/")
    .map(encodeURIComponent)
    .join("/")}`;
};

export const handleDownload = (url) => {
  if (/^https?:\/\//i.test(url)) {
    window.open(resolveStorageUrl(url) || url, "_blank");
    return;
  }
  window.open(`${getStorageBaseUrl()}${String(url || "").replace(/^\//, "")}`, "_blank");
};

/** Format job cities + states for display (supports multi-select). */
export const formatJobLocation = (job) => {
  const cities = Array.isArray(job?.cities)
    ? job.cities.filter(Boolean)
    : job?.cities
      ? [job.cities]
      : [];
  const states = Array.isArray(job?.state)
    ? job.state.filter(Boolean)
    : job?.state
      ? [job.state]
      : [];

  if (cities.length && states.length) {
    return `${cities.join(", ")} · ${states.join(", ")}`;
  }
  if (cities.length) return cities.join(", ");
  if (states.length) return states.join(", ");
  return "";
};

export const getProgressBarColor = (percentage) => {
  if (percentage < 30) {
    return "bg-danger";
  } else if (percentage >= 30 && percentage < 50) {
    return "bg-warning";
  } else if (percentage >= 50 && percentage < 80) {
    return "bg-info";
  } else {
    return "bg-success";
  }
};
export function parseTotalExperience(value) {
  const raw = value?.$numberDecimal ?? value;
  if (raw === null || raw === undefined || raw === "") {
    return null;
  }

  const str = String(raw);
  const dotIndex = str.indexOf(".");

  if (dotIndex === -1) {
    const years = parseInt(str, 10);
    if (Number.isNaN(years)) {
      return null;
    }
    return { years, months: 0 };
  }

  const years = parseInt(str.slice(0, dotIndex), 10) || 0;
  const months = parseInt(str.slice(dotIndex + 1), 10) || 0;

  return { years, months };
}

export function formatTotalExperience(value) {
  const parsed = parseTotalExperience(value);
  if (!parsed) {
    return null;
  }

  const { years, months } = parsed;
  if (years === 0 && months === 0) {
    return null;
  }

  const parts = [];
  if (years > 0) {
    parts.push(`${years} yr${years !== 1 ? "s" : ""}`);
  }
  if (months > 0) {
    parts.push(`${months} mo${months !== 1 ? "s" : ""}`);
  }

  return parts.join(" ");
}

export function getApplicantExperienceDisplay(user) {
  const formatted = formatTotalExperience(user?.total_experience);
  if (formatted) {
    return formatted;
  }
  if (user?.experience_level) {
    return user.experience_level;
  }
  return "Not specified";
}

export function getApplicantCurrentRole(user) {
  const experiences = user?.experience;
  if (!experiences?.length) {
    return null;
  }

  const current =
    experiences.find((entry) => entry?.is_current) || experiences[0];

  return current?.designation || null;
}

export function formatDate(inputDateString) {
  const inputDate = new Date(inputDateString);

  const year = inputDate.getFullYear();
  const month = inputDate.getMonth() + 1; // Months are zero-based, so we add 1
  const day = inputDate.getDate();

  const formattedDateString = `${month < 10 ? "0" : ""}${month}/${
    day < 10 ? "0" : ""
  }${day}/${year}`;

  return formattedDateString;
}

